import type { ReactNode } from "react";
import { Icon } from "@simplybusiness/mobius";
import { tick } from "@simplybusiness/icons";

export function QuoteCardBadge({
  children,
  "data-testid": dataTestId,
}: {
  children: ReactNode;
  "data-testid"?: string;
}) {
  return (
    <div
      className="mobius-quote-card-cancel-anytime__container"
      data-testid={dataTestId}
    >
      <span className="mobius-quote-card-cancel-anytime__badge-icon">
        <Icon icon={tick} color="var(--color-green-500)" aria-hidden="true" />
      </span>
      {children}
    </div>
  );
}
